import "bootstrap";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

//Components
import ImageCarousel from "./components/imageCarousel";
import TextVideo from "./components/textVideo";
import Footer from "./components/footer";
import Header from "./components/header";
import ServicesCarousel from "./components/servicesCarousel";
import FormBlock from "./components/formBlock";
import TestimonialSlider from "./components/testimonialSlider";

for (const block of document.querySelectorAll("section.image-carousel"))
  new ImageCarousel(block);
for (const block of document.querySelectorAll("section.text-video"))
  new TextVideo(block);
for (const block of document.querySelectorAll(".site-footer"))
  new Footer(block);
for (const block of document.querySelectorAll(".site-header"))
  new Header(block);
for (const block of document.querySelectorAll(".services-carousel"))
  new ServicesCarousel(block);
for (const block of document.querySelectorAll(".form-block"))
  new FormBlock(block);
for (const block of document.querySelectorAll(".testimonial-slider"))
  new TestimonialSlider(block);
